import { __ } from '@wordpress/i18n';
import { Panel, PanelBody, PanelRow, TextControl, Button, ToolbarGroup, ToolbarButton, ToggleControl } from "@wordpress/components";
import { MediaUpload, MediaUploadCheck } from "@wordpress/block-editor";
import { useBlockProps, InspectorControls, URLPopover } from "@wordpress/block-editor";
import { registerBlockType } from "@wordpress/blocks";
import { useState, useEffect } from '@wordpress/element';
import apiFetch from '@wordpress/api-fetch';
import metadata from "./block.json";

/* import 'bootstrap/dist/css/bootstrap-grid.min.css'; */
import "./index.scss";



registerBlockType(metadata.name, {...metadata, edit: EditComponent });

function EditComponent(props) {
  const { attributes, setAttributes } = props;
  const { opcoes, titulo } = attributes;

  const [isURLPopoverVisible, setURLPopoverVisible] = useState(false);
  const [selectedURL, setSelectedURL] = useState('');
  const [currentIndex, setCurrentIndex] = useState(null);
  const [postLinks, setPostLinks] = useState([]);
  const [pageLinks, setPageLinks] = useState([]);
  const [formacoesLinks, setFormacoesLinks] = useState([]);
  const [searchTerm, setSearchTerm] = useState('');

  const setOpcoesTitulo = (index, titulo) => {
    const newOpcoes = [...opcoes];
    newOpcoes[index] = { ...newOpcoes[index], titulo: titulo };
    setAttributes({ opcoes: newOpcoes });
  };

  const setOpcoesDescricao = (index, descricao) => {
    const newOpcoes = [...opcoes];
    newOpcoes[index] = { ...newOpcoes[index], descricao: descricao };
    setAttributes({ opcoes: newOpcoes });
  };

  const setOpcoesIcon = (index, icon) => {
    const newOpcoes = [...opcoes];
    newOpcoes[index] = { ...newOpcoes[index], id: icon.id, url: icon.url };
    setAttributes({ opcoes: newOpcoes });
  };

  const setOpcoesLink = (index, link) => {
    const newOpcoes = [...opcoes];
    newOpcoes[index] = { ...newOpcoes[index], link: link };
    setAttributes({ opcoes: newOpcoes });
  };

  const setOpcoesTarget = (index, target) => {
    const newOpcoes = [...opcoes];
    newOpcoes[index] = { ...newOpcoes[index], target: target };
    setAttributes({ opcoes: newOpcoes });
  };

  const addOpcoes = () => {
    const newOpcoes = [...opcoes, { titulo: "", descricao: "", id: null, url: null, link: "" , target: "internal"}];
    setAttributes({ opcoes: newOpcoes });
  };

  const handleOpcoesRemove = (index) => {
    const newOpcoes = [...opcoes];
    newOpcoes.splice(index, 1);
    setAttributes({ opcoes: newOpcoes });
  };

  const moveOpcoesUp = (index) => {
    if (index === 0) return;
    const newOpcoes = [...opcoes];
    const temp = newOpcoes[index - 1];
    newOpcoes[index - 1] = newOpcoes[index];
    newOpcoes[index] = temp;
    setAttributes({ opcoes: newOpcoes });
  };

  const moveOpcoesDown = (index) => {
    if (index === opcoes.length - 1) return;
    const newOpcoes = [...opcoes];
    const temp = newOpcoes[index + 1];
    newOpcoes[index + 1] = newOpcoes[index];
    newOpcoes[index] = temp;
    setAttributes({ opcoes: newOpcoes });
  };

  const openURLPopover = (index) => {
    setCurrentIndex(index);
    setSelectedURL(opcoes[index].link || '');
    setURLPopoverVisible(true);
  
    // Fetch post and page links when the popover is opened
    const fetchPosts = apiFetch({ path: '/wp/v2/posts?per_page=-1' });
    const fetchPages = apiFetch({ path: '/wp/v2/pages?per_page=-1' });
    const fetchFormacoes = apiFetch({ path: '/wp/v2/formacoes-posts?per_page=-1' });
  
    Promise.all([fetchPosts, fetchPages, fetchFormacoes]).then(([posts, pages, formacoes]) => {
      const postLinks = posts.map(post => ({ id: post.id, title: post.title.rendered, link: post.link, type: 'post' }));
      const pageLinks = pages.map(page => ({ id: page.id, title: page.title.rendered, link: page.link, type: 'page' }));
      const formacoesLinks = formacoes.map(formacoes => ({ id: formacoes.id, title: formacoes.title.rendered, link: formacoes.link, type: 'formacoes-posts' }));
      setPostLinks(postLinks.sort((a, b) => a.title.localeCompare(b.title)));
      setPageLinks(pageLinks.sort((a, b) => a.title.localeCompare(b.title)));
      setFormacoesLinks(formacoesLinks.sort((a, b) => a.title.localeCompare(b.title)));
    });
  };
  

  const saveURL = () => {
    setOpcoesLink(currentIndex, selectedURL);
    setURLPopoverVisible(false);
  };

  const filteredPageLinks = pageLinks.filter(page =>
    page.title.toLowerCase().includes(searchTerm.toLowerCase())
  );
  
  const filteredPostLinks = postLinks.filter(post =>
    post.title.toLowerCase().includes(searchTerm.toLowerCase())
  );
  
  const filteredFormacoesLinks = formacoesLinks.filter(formacoes =>
    formacoes.title.toLowerCase().includes(searchTerm.toLowerCase())
  );

  return (
    <>
      <div id="parent" {...useBlockProps()}>
        <div id="child">
          <h2> Editar os atalhos</h2>
          <div className="container container-max">
            <div className="row">
              {opcoes.map((opcao, index) => (
                <div className="col-lg-3" key={index}>
                  <a href className="shortcut d-flex align-items-center">
                    <div className="flex-shrink-0">
                      <ToolbarGroup>
                        <ToolbarButton
                          icon="arrow-left-alt2"
                          label={__('Move Up', 'text-domain')}
                          onClick={() => moveOpcoesUp(index)}
                          disabled={index === 0} />
                        <ToolbarButton
                          icon="arrow-right-alt2"
                          label={__('Move Down', 'text-domain')}
                          onClick={() => moveOpcoesDown(index)}
                          disabled={index === opcoes.length - 1} />
                      </ToolbarGroup>

                      <br />
                      <br />
                      <MediaUploadCheck>
                        <MediaUpload
                          onSelect={(imagem) => setOpcoesIcon(index, imagem)}
                          allowedTypes={['image']}
                          value={opcao.id}
                          render={({ open }) => (
                            <Button onClick={open}>
                              {opcao.url ? (
                                <img src={opcao.url} alt={__('Image', 'text-domain')} style={{ maxWidth: '100%' }} />
                              ) : (
                                __('Upload Image', 'text-domain')
                              )}
                            </Button>
                          )} />
                      </MediaUploadCheck>
                    </div>
                    <div className="flex-grow-1 ms-4">
                      <h3 className="title-shortcut mb-2">
                        <TextControl
                          label={__('Título', 'text-domain')}
                          value={opcao.titulo}
                          onChange={(e) => setOpcoesTitulo(index, e)} />
                      </h3>
                      <p className="description">
                        <TextControl
                          label={__('Descrição', 'text-domain')}
                          value={opcao.descricao}
                          onChange={(e) => setOpcoesDescricao(index, e)} />
                      </p>
                      <div class="d-flex align-items-end">
                        <Button className='mt-3 mb-2 me-2' isPrimary onClick={() => openURLPopover(index)}>
                          { __('Ligação') }
                        </Button>
                        <ToggleControl
                          label="Ligação Externa"
                          checked={opcao.target === 'external'}
                          onChange={(checked) => setOpcoesTarget(index, checked ? 'external' : 'internal')}
                        />
                      </div>
                    </div>
                  </a>
                  <Button isDestructive onClick={() => handleOpcoesRemove(index)}>Remover Atalho</Button>
                  <br /><br />
                </div>
              ))}
            </div>
          </div>
          <br />
          {opcoes.length < 4 ? (
            <Button isPrimary onClick={addOpcoes}>Adicionar Atalho</Button>
          ) : (
            <p>Você atingiu o limite de 4 atalhos.</p>
          )}

          {isURLPopoverVisible && (
            <URLPopover onClose={() => setURLPopoverVisible(false)}>
              <div style={{ padding: '8px' }}>
                <TextControl
                  label={ __('URL') }
                  value={ selectedURL }
                  onChange={(url) => setSelectedURL(url)}
                />
                <TextControl
                  label={__('Search')}
                  value={searchTerm}
                  onChange={(value) => setSearchTerm(value)}
                  placeholder={__('Search by title...', 'text-domain')}
                />
                <h4>{__('Pages', 'text-domain')}</h4>
                <ul>
                  {filteredPageLinks.map((page) => (
                    <li key={page.id}>
                      <Button isLink onClick={() => setSelectedURL(page.link)}>
                        {page.title}
                      </Button>
                    </li>
                  ))}
                </ul>
                <h4>{__('Notícias', 'text-domain')}</h4>
                <ul>
                  {filteredPostLinks.map((post) => (
                    <li key={post.id}>
                      <Button isLink onClick={() => setSelectedURL(post.link)}>
                        {post.title}
                      </Button>
                    </li>
                  ))}
                </ul>
                <h4>{__('Formações', 'text-domain')}</h4>
                <ul>
                  {filteredFormacoesLinks.map((formacoes) => (
                    <li key={formacoes.id}>
                      <Button isLink onClick={() => setSelectedURL(formacoes.link)}>
                        {formacoes.title}
                      </Button>
                    </li>
                  ))}
                </ul>
                <Button isPrimary onClick={saveURL}>
                  { __('Save') }
                </Button>
              </div>
            </URLPopover>
          )}

        </div>
      </div>
    </>
  );
}
